export default "__VITE_ASSET__DhfTilcs__"